import React from 'react';
import EnquiryForm from '../components/EnquiryForm';
import { Phone, Mail, MessageCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const Enquiry = () => {
  const { t } = useTranslation();

  return (
    <div className="pt-10">
      <section className="bg-dark-green py-20 text-white">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">{t('enquiryPage.header.title')}</h1>
          <p className="text-xl text-gold-light max-w-2xl mx-auto">
            {t('enquiryPage.header.subtitle')}
          </p>
        </div>
      </section>

      <section className="py-20 bg-cream-off">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
            <div className="lg:col-span-2">
              <EnquiryForm />
            </div>
            <div className="space-y-8">
              <div className="bg-white p-8 rounded-2xl shadow-lg border border-gold-primary/20">
                <h3 className="text-2xl font-bold text-dark-green mb-6">{t('enquiryPage.immediate')}</h3>
                <div className="space-y-6">
                  <div className="flex flex-col space-y-4">
                    <a href="tel:8936835037" className="flex items-center space-x-4 group">
                      <div className="bg-dark-green p-3 rounded-lg group-hover:bg-gold-primary transition-colors">
                        <Phone className="text-white" size={20} />
                      </div>
                      <div>
                        <p className="text-sm text-gray-500">{t('enquiryPage.labels.call')}</p>
                        <p className="font-bold text-dark-green">+91 8936835037</p>
                      </div>
                    </a>
                    <a href="tel:9136556703" className="flex items-center space-x-4 group ml-14">
                      <p className="text-xs text-gray-400 font-medium">Alternative: +91 9136556703</p>
                    </a>
                  </div>
                  
                  <a href="https://wa.me/918936835037" className="flex items-center space-x-4 group">
                    <div className="bg-green-whatsapp p-3 rounded-lg group-hover:opacity-90 transition-opacity">
                      <MessageCircle className="text-white" size={20} />
                    </div>
                    <div>
                      <p className="text-sm text-gray-500">{t('enquiryPage.labels.whatsapp')}</p>
                      <p className="font-bold text-dark-green">Click to Chat</p>
                    </div>
                  </a>
                  <a href="mailto:vskassociates91665@gmail.com" className="flex items-center space-x-4 group">
                    <div className="bg-gold-primary p-3 rounded-lg group-hover:bg-dark-green transition-colors">
                      <Mail className="text-white" size={20} />
                    </div>
                    <div>
                      <p className="text-sm text-gray-500">{t('enquiryPage.labels.email')}</p>
                      <p className="font-bold text-dark-green text-sm break-all">vskassociates91665@gmail.com</p>
                    </div>
                  </a>
                </div>
              </div>

              <div className="bg-dark-green p-8 rounded-2xl shadow-lg text-white">
                <h4 className="text-xl font-bold mb-4 text-gold-primary">{t('enquiryPage.why.title')}</h4>
                <ul className="space-y-4">
                  {t('enquiryPage.why.points', { returnObjects: true }).map((point, i) => (
                    <li key={i} className="flex items-start space-x-3">
                      <div className="w-1.5 h-1.5 bg-gold-primary rounded-full mt-2"></div>
                      <p className="text-sm">{point}</p>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Enquiry;
